
/**
 * @description 格式化列表数据 -- 数据字典转换
 * @param {*} data
 */
const formatTotalDataList = (data, dictData) => {
    if (!data.length) return [];
    data.forEach((item) => {
        item.statusName = +item.status === 1 ? '已运抵' : '未运抵';
        item.siteTypeName = dictData.SITE_TYPE[item.siteType];
        item.arrivalConfirmTypeName = dictData.ARRIVER_WAY[item.arrivalConfirmType];
        item.deliveryTypeName = dictData.DELIVERY_TYPE[item.deliveryType];
    });
    return data;
};
export { formatTotalDataList };